import {Component, OnInit} from "@angular/core";
import {BsModalRef} from "ngx-bootstrap";
import {Subject} from "rxjs";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";

@Component({
    selector: 'app-custom-tag-modal',
    templateUrl: './custom-tag-modal.component.html',
    styleUrls: ['./custom-tag-modal.component.scss']
})
export class CustomTagModalComponent implements OnInit {
    action = 'save';
    onClose: Subject<any>;
    dropdownOptions: any = [];
    formData: any = {};
    fieldType = '';
    options: any;
    value: any;
    constructor(public bsModalRef: BsModalRef,) {}

    ngOnInit() {
        this.onClose = new Subject();
        if(this.action == 'edit') {
            if(this.fieldType == 'dropdown') {
                this.formData.fieldType = this.fieldType;
                this.dropdownOptions = this.options;
            }
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.dropdownOptions, event.previousIndex, event.currentIndex);
    }

    onSelectFieldType(ev) {
        this.formData['fieldType'] = ev.target.value;
    }

    onAddOption() {
        if (this.formData.fieldType === 'dropdown' && this.formData.newOption) {
            this.dropdownOptions.push(this.formData.newOption);
            this.formData.newOption = ''; // Clear the input after adding
        }
    }

    onRemoveOption(index: number) {
        this.dropdownOptions.splice(index, 1);
    }

    saveCT() {
        const value = {fieldType: this.fieldType, options: this.fieldType === 'dropdown' ? this.dropdownOptions : null, action: this.action, value: this.value, denotationChar: '{'};
        this.onClose.next(value);
        this.bsModalRef.hide();
    }

}